import { EStoreType } from "../orders-replacement/orders-replacement.interface";
import { IProductEntity } from "../products/products.interface";

export interface IStockEntity {
    id: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    productId: string;
    omieId: number;
    action: "ADD" | "REMOVE";
    omieStock: string;
    store: EStoreType;
    howMany: number;
    unitaryPrice: string;
    orderId: string | null;
    serviceOrderId: string | null;
    stockProductManagerId: string;
}

export interface IStocksListPayload {
     page : number; 
     search?: string;
}
export interface IStockManagerListEntity {
    id: string
	store: EStoreType;
	productId: string;
	newRequestOrderQuantity: number;
	newServiceOrderQuantity: number;
	producedQuantity: number;

    allocatedStockQuantity: number;
    workInProgressQuantity: number;
    finishedGoodsQuantity: number
    stockSKUManagerId?: string;
    product?: IProductEntity
}

export interface IUpdateStockPayload {
    data: FormData;
    id: string
}

export enum STockMovimentationEnum {
    PRODUCED = 'finishedGoods',
    NEW_REQUEST_ORDER = 'allocatedStock',
    NEW_SERVICE_ORDER = 'workInProgress',

}

export enum EStockNameEnum {
    EMPENHO = 'allocatedStock',
    PRODUCAO = 'workInProgress',
    ACABADO = 'finishedGoods',
}

export interface IShowStocksByProductPayload {
    productId: string
    startDate: string
    endDate: string
    stockName?: EStockNameEnum
}

export interface IShowStocksByProductResponse {
    product: IProductEntity
    stocks: IStockEntity[]
    totalQuantity: number
}

export interface ICreateStockPayload {
    productId: string
    store: EStoreType
    howMany: number
    action: 'add' | 'remove' | 'adjust'
    toStock?: STockMovimentationEnum
    fromStock?: STockMovimentationEnum
    description: string
}

export interface IGetStockPayload {
    page: number
    search?: string
}

export interface IProductImageEntity {
    link: string
    nsId: number
}
export interface IStocksListResponse {
    data:  {
        allocatedStockQuantity: number;
        workInProgressQuantity: number
        finishedGoodsQuantity:number
        productId: string
        productName: string
        productInternalName: string
        productImages: IProductImageEntity[]
    }[]
    total: number
    hasNextPage: boolean
}